import type { IconProps } from './types';

export function Logo(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="932.613"
      height="223.141"
      version="1.1"
      viewBox="0 0 932.613 223.141"
      xmlSpace="preserve"
      {...props}
    >
      <defs>
        <clipPath id="clipPath16" clipPathUnits="userSpaceOnUse">
          <path d="M0 400h1000V0H0z"></path>
        </clipPath>
        <clipPath id="clipPath56" clipPathUnits="userSpaceOnUse">
          <path d="M0 400h1000V0H0z"></path>
        </clipPath>
      </defs>
      <g transform="matrix(1.33333 0 0 -1.33333 -86.973 402.958)">
        <g>
          <g clipPath="url(#clipPath16)">
            <g transform="translate(246.039 162.023)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0l6.077 65.433c.216 3.255 2.17 4.992 5.425 4.992h7.813c3.039 0 4.884-1.302 6.077-4.124L44.707 19.1l19.424 47.201c1.086 2.822 3.038 4.124 5.969 4.124h7.921c3.255 0 5.1-1.737 5.426-4.992L89.523 0c.326-3.581-1.519-5.534-4.991-5.534h-6.619c-3.365 0-5.209 1.737-5.535 4.992L68.906 40.91 52.195-.542c-1.085-2.821-3.038-4.124-5.968-4.124h-2.93c-2.93 0-4.883 1.303-5.968 4.124L20.617 40.91 17.037-.542c-.217-3.255-2.17-4.992-5.426-4.992H4.992C1.52-5.534-.435-3.581 0 0"
              ></path>
            </g>
            <g transform="translate(348.358 161.698)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v45.358c0 3.365 1.845 5.208 5.208 5.208h6.294c3.364 0 5.318-1.843 5.318-5.208V0c0-3.364-1.954-5.209-5.318-5.209H5.208C1.845-5.209 0-3.364 0 0m-1.737 65.867c0 4.992 3.582 8.789 10.092 8.789 6.403 0 10.092-3.797 10.092-8.789 0-4.883-3.906-8.681-10.092-8.681-6.185 0-10.092 3.798-10.092 8.681"
              ></path>
            </g>
            <g transform="translate(378.738 161.698)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v45.358c0 3.365 1.845 5.208 5.209 5.208h6.402c3.364 0 5.209-1.843 5.209-5.208v-3.689c2.712 6.403 8.68 10.092 16.928 10.092 14.975 0 20.4-11.72 20.4-24.85V0c0-3.364-1.953-5.209-5.317-5.209h-6.293c-3.365 0-5.209 1.845-5.209 5.209v25.717c0 7.813-3.039 12.371-8.79 12.371-5.75 0-11.719-4.448-11.719-14.866V0c0-3.364-1.845-5.209-5.209-5.209H5.209C1.845-5.209 0-3.364 0 0"
              ></path>
            </g>
            <g transform="translate(487.246 184.378)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-.108 8.897-5.751 15.625-14.324 15.625-8.68 0-13.889-7.053-13.889-15.625 0-8.682 5.209-15.626 13.889-15.626C-5.751-15.626-.108-8.897 0 0m-45.033 0c0 16.386 11.177 29.081 26.911 29.081 7.27 0 13.781-2.822 17.797-9.115v25.392c0 3.363 1.953 5.208 5.317 5.208h6.294c3.363 0 5.208-1.845 5.208-5.208V-22.68c0-3.364-1.845-5.209-5.208-5.209H4.992c-3.364 0-5.317 1.845-5.317 5.209v2.605c-4.016-6.186-10.527-9.007-17.797-9.007-15.734 0-26.911 12.588-26.911 29.082"
              ></path>
            </g>
            <g transform="translate(519.903 161.698)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0v65.542c0 3.364 1.953 5.208 5.317 5.208h6.728c3.364 0 5.209-1.844 5.209-5.208V9.332h29.081c3.364 0 5.317-1.845 5.317-5.209V0c0-3.364-1.953-5.209-5.317-5.209H5.317C1.953-5.209 0-3.364 0 0"
              ></path>
            </g>
            <g transform="translate(621.574 184.378)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c0 8.897-5.643 15.625-14.215 15.625-8.79 0-13.89-7.053-13.89-15.625 0-8.682 5.1-15.626 13.89-15.626C-5.643-15.626 0-8.897 0 0m-44.924 0c0 16.386 11.177 29.081 26.802 29.081 7.379 0 13.89-2.822 17.905-9.115v2.713c0 3.364 1.845 5.207 5.208 5.207h6.404c3.363 0 5.208-1.843 5.208-5.207V-22.68c0-3.364-1.845-5.209-5.208-5.209H4.991c-3.363 0-5.208 1.845-5.208 5.209v2.605c-4.015-6.186-10.526-9.007-17.905-9.007-15.625 0-26.802 12.588-26.802 29.082"
              ></path>
            </g>
            <g transform="translate(696.332 184.378)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c0 8.572-5.208 15.625-13.89 15.625-8.679 0-14.214-6.728-14.323-15.625.109-8.897 5.644-15.626 14.323-15.626C-5.208-15.626 0-8.682 0 0m-27.887-20.075v-2.605c0-3.364-1.954-5.209-5.317-5.209h-6.294c-3.364 0-5.208 1.845-5.208 5.209v68.038c0 3.363 1.844 5.208 5.208 5.208h6.294c3.363 0 5.317-1.845 5.317-5.208V19.966c4.015 6.293 10.526 9.115 17.796 9.115C5.645 29.081 16.82 16.386 16.82 0c0-16.494-11.175-29.082-26.911-29.082-7.27 0-13.781 2.821-17.796 9.007"
              ></path>
            </g>
            <g transform="translate(720.633 166.474)">
              <path
                fill="#160123"
                fillOpacity="1"
                fillRule="nonzero"
                stroke="none"
                d="M0 0c-1.628 3.255.107 5.643 3.472 6.511l3.364.759c2.93.759 4.232-.652 6.511-2.93 1.953-2.171 4.882-3.255 8.356-3.255 4.231 0 7.161 1.952 7.161 4.883 0 2.386-1.628 3.58-5.209 4.883l-6.837 2.386c-5.75 1.846-15.733 6.077-15.733 16.17 0 10.417 8.681 17.578 20.726 17.578 7.162 0 13.672-2.278 17.796-8.464 2.169-3.146.541-5.968-3.039-6.835l-3.038-.76c-2.822-.76-4.341.217-6.294 2.062-1.518 1.518-3.473 2.061-5.425 2.061-3.472 0-5.643-2.17-5.643-4.776 0-2.386 2.171-3.58 5.101-4.555l6.945-2.606c11.501-3.798 15.624-9.983 15.843-16.819 0-11.719-10.419-17.471-22.463-17.471C11.719-11.178 3.689-7.488 0 0"
              ></path>
            </g>
          </g>
        </g>
        <g>
          <g clipPath="url(#clipPath56)">
            <g transform="translate(130.358 232.354)">
              <path
                fill="#ff8b00"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0c9.156 0 16.578 7.422 16.578 16.578 0 9.156-7.422 16.578-16.578 16.578-9.156 0-16.578-7.422-16.578-16.578C-16.578 7.422-9.156 0 0 0"
              ></path>
            </g>
            <g transform="translate(157.594 264.326)">
              <path
                fill="#8657f3"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0c6.54 0 11.841 5.301 11.841 11.841 0 6.54-5.301 11.842-11.841 11.842-6.54 0-11.842-5.302-11.842-11.842C-11.842 5.301-6.54 0 0 0"
              ></path>
            </g>
            <g transform="translate(122.07 285.64)">
              <path
                fill="#fc3d80"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0a8.289 8.289 0 110 16.578A8.289 8.289 0 110 0"
              ></path>
            </g>
            <g transform="translate(135.479 184.34)">
              <path
                fill="#ff8b00"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0l-46.066-45.389c-5.59-5.508-14.587-5.441-20.095.149a14.207 14.207 0 00-4.088 9.973V55.51c0 7.848 6.362 14.21 14.21 14.21 3.732 0 7.314-1.469 9.973-4.088L0 20.244C5.59 14.735 5.657 5.738.149.148L0 0"
              ></path>
            </g>
            <g transform="translate(130.358 179.294)">
              <path
                fill="#fc3d80"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0l-20.242-19.944 10.12-10.271c5.508-5.59 14.505-5.656 20.095-.148l.149.148 10.119 10.272z"
              ></path>
            </g>
            <g transform="translate(181.276 254.06)">
              <path
                fill="#8657f3"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0a14.212 14.212 0 01-9.973-4.087l-40.945-40.344 5.121-5.045c5.59-5.508 5.656-14.505.149-20.095l-.149-.149-5.121-5.046 40.945-40.342c5.59-5.509 14.587-5.442 20.095.148a14.207 14.207 0 014.088 9.974v90.777C14.21-6.362 7.848 0 0 0"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function LogoIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="533.333"
      height="533.333"
      version="1.1"
      viewBox="0 0 533.333 533.333"
      xmlSpace="preserve"
      {...props}
    >
      <defs>
        <clipPath id="clipPath16" clipPathUnits="userSpaceOnUse">
          <path d="M0 400h400V0H0z"></path>
        </clipPath>
      </defs>
      <g transform="matrix(1.33333 0 0 -1.33333 0 533.333)">
        <g>
          <g clipPath="url(#clipPath16)">
            <g transform="translate(199.123 211.586)">
              <path
                fill="#ff8b00"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0c9.156 0 16.578 7.422 16.578 16.578 0 9.156-7.422 16.578-16.578 16.578-9.156 0-16.578-7.422-16.578-16.578C-16.578 7.422-9.156 0 0 0"
              ></path>
            </g>
            <g transform="translate(226.358 243.558)">
              <path
                fill="#8657f3"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0c6.54 0 11.842 5.302 11.842 11.842 0 6.539-5.302 11.841-11.842 11.841-6.54 0-11.842-5.302-11.842-11.841C-11.842 5.302-6.54 0 0 0"
              ></path>
            </g>
            <g transform="translate(190.834 264.873)">
              <path
                fill="#fc3d80"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0a8.289 8.289 0 110 16.578A8.289 8.289 0 110 0"
              ></path>
            </g>
            <g transform="translate(204.244 163.571)">
              <path
                fill="#ff8b00"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0l-46.066-45.389c-5.591-5.507-14.587-5.44-20.095.15a14.206 14.206 0 00-4.088 9.972v90.778c0 7.848 6.362 14.21 14.209 14.21 3.733 0 7.315-1.469 9.974-4.088L0 20.244C5.59 14.736 5.656 5.739.148.149L0 0"
              ></path>
            </g>
            <g transform="translate(199.123 158.526)">
              <path
                fill="#fc3d80"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0l-20.242-19.944 10.12-10.271c5.508-5.59 14.505-5.656 20.095-.148l.149.148 10.119 10.271z"
              ></path>
            </g>
            <g transform="translate(250.041 233.292)">
              <path
                fill="#8657f3"
                fillOpacity="1"
                fillRule="evenodd"
                stroke="none"
                d="M0 0a14.21 14.21 0 01-9.973-4.088l-40.945-40.343 5.121-5.046c5.59-5.507 5.656-14.504.149-20.094l-.149-.15-5.121-5.045 40.945-40.342c5.59-5.509 14.587-5.442 20.095.148a14.207 14.207 0 014.088 9.973v90.778C14.21-6.362 7.848 0 0 0"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
